'use es6';

import { useCallback, useState, useMemo } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Button } from 'foundations-components/transitional/components/Button';
import { List } from 'foundations-components/transitional/components/List';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommentActions = ({
  handleClickToDelete,
  onClickToDeleteComment
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const onDeleteComment = useCallback(() => {
    handleClickToDelete();
    setModalOpen(false);
  }, [handleClickToDelete, setModalOpen]);
  const onOpenModal = useCallback(() => {
    onClickToDeleteComment();
    setModalOpen(true);
  }, [onClickToDeleteComment, setModalOpen]);
  const onCloseModal = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);
  const deleteCommentModal = useMemo(() => {
    return /*#__PURE__*/_jsxs(Modal, {
      use: "danger",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onCloseModal
        }), /*#__PURE__*/_jsx("h2", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.commentActions.dialogBody"
          })
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.commentActions.dialogFooter"
          })
        })
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onDeleteComment,
          "data-test-id": 'delete-comment-button',
          use: "danger",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.commentActions.deleteCommentButton"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onCloseModal,
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.commentActions.cancel"
          })
        })]
      })]
    });
  }, [onDeleteComment, onCloseModal]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Dropdown, {
      "data-test-id": 'actions-dropdown',
      buttonUse: "transparent",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.commentActions.actions"
      }),
      buttonSize: "extra-small",
      children: /*#__PURE__*/_jsx(List, {
        wrapChildren: true,
        children: /*#__PURE__*/_jsx(Button, {
          use: "link",
          "data-test-id": 'open-modal-button',
          onClick: onOpenModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.commentActions.deleteCommentButton"
          })
        })
      })
    }), isModalOpen ? deleteCommentModal : null]
  });
};
CommentActions.displayName = 'CommentActions';
CommentActions.propTypes = {
  handleClickToDelete: PropTypes.func.isRequired,
  onClickToDeleteComment: PropTypes.func.isRequired
};
export default CommentActions;